import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, Inject, OnInit, Renderer2, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml, SafeResourceUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { LoginModel } from 'src/app/model/login.model';
import { DetalheRegistroTransacaoComponent } from 'src/app/registro-transacoes/detalhe-registro-transacao/detalhe-registro-transacao.component';
import { RegistroTransacoesService } from 'src/app/registro-transacoes/registro-transacoes.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { SnackBarService } from 'src/app/services/snack-bar-service.service';
import { IVeiculosBloqueioViewModel } from '../model/bloqueioTransacao.model';
import { environment } from 'src/environments/environment';
import { ExtendedMatTableComponent } from 'src/app/components/extended-mat-table/extended-mat-table.component';
import { Subscription } from 'rxjs';
import { MatSortable } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { IDadosListaBloqueio } from '../model/bloqueio.model';
import { TipoEntidades } from 'src/app/subFrota/model/TipoEntidades';

@Component({
  selector: 'app-lista-bloqueios',
  templateUrl: './lista-bloqueios.component.html',
  styleUrls: ['./lista-bloqueios.component.scss']
})
export class ListaBloqueiosComponent implements OnInit, AfterViewInit {


  @ViewChild(ExtendedMatTableComponent) extendedTable!: ExtendedMatTableComponent;

  usuario !: LoginModel | undefined;
  loading = 0;
  dadosLista!: MatTableDataSource<IVeiculosBloqueioViewModel> | any;
  acaoRapida: boolean = false;
  byPass: boolean = false;
  url_redirect: SafeResourceUrl | undefined;
  ocultarDadosDetalhes: boolean = false;
  content: SafeHtml = '';
  textoBtnDetalhe: string = '';

  public tituloFuncionalidade: any = "";
  public columnRowData: any = "";
  public columns: any[] = [];
  public dataSource: any[] = [];
  public filteredList: any[] = [];
  //public dataSource!: MatTableDataSource<IVeiculosBloqueioViewModel>;

  templateColunas = [
    {
      cmdName: 7,
      tituloRelatorio: "Lista de bloqueios",
      filtro: [],
      colunas: [
        { columnDef: "placa", header: "Placa", format: null },
        { columnDef: "modeloVeiculo", header: "Modelo", format: null },
        { columnDef: "numeroDeFrota", header: "Nº do Frota", format: null },

        {
          columnDef: "ACAO_DETALHES", header: "Detalhes", tituloMenu: "teste", format: null, orderBy: false, cssClass: "menuAcao", actions: [
            {
              titulo: "Ver mais", link: "chamarTelaDestino", tipo: "FUNCTION_ROW", cssClass: "btnVermais", parametros: [
                { "nome": "ROW", "valor": "ROW" }
              ]
            }
          ]
        }
      ],
      columnDefinitions:
        { columnDef: "ROW_COLOR" }

    },
    {
      cmdName: 6,
      tituloRelatorio: "Lista de bloqueios",
      filtro: [],
      colunas: [
        { columnDef: "codigoSubfrota", header: "Códígo", format: null },
        { columnDef: "descricaoSubFrota", header: "Subfrota", format: null },

        {
          columnDef: "ACAO_DETALHES", header: "Detalhes", tituloMenu: "teste", format: null, orderBy: false, cssClass: "menuAcao", actions: [
            {
              titulo: "Ver mais", link: "chamarTelaDestino", tipo: "FUNCTION_ROW", cssClass: "btnVermais", parametros: [
                { "nome": "ROW", "valor": "ROW" }
              ]
            }
          ]
        }
      ],
      columnDefinitions:
        { columnDef: "ROW_COLOR" }

    },
    {
      cmdName: 2,
      tituloRelatorio: "Lista de bloqueios",
      filtro: [],
      colunas: [
        { columnDef: "codigoFrota", header: "Códígo", format: null },
        { columnDef: "fantasiaFrota", header: "Frota", format: null },

        {
          columnDef: "ACAO_DETALHES", header: "Detalhes", tituloMenu: "teste", format: null, orderBy: false, cssClass: "menuAcao", actions: [
            {
              titulo: "Ver mais", link: "chamarTelaDestino", tipo: "FUNCTION_ROW", cssClass: "btnVermais", parametros: [
                { "nome": "ROW", "valor": "ROW" }
              ]
            }
          ]
        }
      ],
      columnDefinitions:
        { columnDef: "ROW_COLOR" }

    }
  ];


  //todos os erros e caminhos de destinos
  erroMapeamento = [
    {
      erro: 1,
      tipoEntidade: 2,
      dscerro: "FROTA BLOQUEADO",
      url: environment.sistemas.online_url + "/login.aspx?cmdName=1693",
      bypass: "N",
      parametros: [
        { nome: "CodFrota", valor: "codigoFrota" }
      ]
    },
    {
      erro: 1,
      tipoEntidade: 6,
      dscerro: "SUBFROTA BLOQUEADO",
      url: environment.sistemas.online_url + "/login.aspx?cmdName=1693",
      bypass: "N",
      parametros: [
        { nome: "CodFrota", valor: "codigoFrota" },
        { nome: "CodSubFrota", valor: "codigoSubfrota" },
      ]
    },
    {
      erro: 1,
      tipoEntidade: 7,
      dscerro: "VEICULO BLOQUEADO",
      url: environment.sistemas.cardsveiculo_url + "/login/Index?cmdName=2290",
      bypass: "N",
      parametros: [
        { nome: "placa", valor: "placa" },
      ]
    },    
    {
      erro: 2,
      tipoEntidade: 7,
      dscerro: "Controle SALDO",
      url: environment.sistemas.portal_url + "/login/index?cmdName=92285", 
      bypass: "N",
      parametros: [
        { nome: "id", valor: "codigoVeiculo" },
        { nome: "idCartao", valor: "codProdutoCartao" }
      ]
    },
    {
      erro: 3,
      tipoEntidade: 7,
      dscerro: "Consumo MÍN/MÁX",
      url: environment.sistemas.cardsveiculo_url + "/login/Index?cmdName=2290",
      bypass: "N",
      parametros: [
        { nome: "placa", valor: "placa" },
      ]
    },
    {
      erro: 4,
      tipoEntidade: 7,
      dscerro: "Feriados",
      url: environment.sistemas.cardsveiculo_url + "/login/Index?cmdName=2290",
      bypass: "N",
      parametros: [
        { nome: "placa", valor: "placa" },
      ]
    },
    {
      erro: 5,
      tipoEntidade: 7,
      dscerro: "Dias da semana",
      url: environment.sistemas.cardsveiculo_url + "/login/Index?cmdName=2290",
      bypass: "N",
      parametros: [
        { nome: "placa", valor: "placa" },
      ]
    },
    {
      erro: 6,
      tipoEntidade: 2,
      dscerro: "Postos bloqueados",
      url: environment.sistemas.online_url + "/login.aspx?cmdName=2062",
      bypass: "N",
      parametros: [
        { nome: "CodFrota", valor: "codigoFrota" }      
      ]
    },
    {
      erro: 6,
      tipoEntidade: 6,
      dscerro: "Postos bloqueados",
      url: environment.sistemas.online_url + "/login.aspx?cmdName=2062",
      bypass: "N",
      parametros: [
        { nome: "CodFrota", valor: "codigoFrota" },
        { nome: "CodSubFrota", valor: "codigoSubfrota" }     
      ]
    },
    {
      erro: 6,
      tipoEntidade: 7,
      dscerro: "Postos bloqueados",
      url: environment.sistemas.online_url + "/login.aspx?cmdName=2062",
      bypass: "N",
      parametros: [
        { nome: "CodFrota", valor: "codigoFrota" },
        { nome: "CodSubFrota", valor: "codigoSubfrota" },        
        { nome: "CodVeiculo", valor: "codigoVeiculo" }        
      ]
    },
    {
      erro: 7,
      tipoEntidade: 7,
      dscerro: "KMs Percorridos",
      url: environment.sistemas.cardsveiculo_url + "/login/Index?cmdName=2290",
      bypass: "N",
      parametros: [
        { nome: "placa", valor: "placa" },
      ]
    },
    {
      erro: 8,
      tipoEntidade: 7,
      dscerro: "Tempo Percorrido",
      url: environment.sistemas.cardsveiculo_url + "/login/Index?cmdName=2290",
      bypass: "N",
      parametros: [
        { nome: "placa", valor: "placa" },
      ]
    },
    {
      erro: 9,
      tipoEntidade: 2,
      dscerro: "Horário",
      url: environment.sistemas.online_url + "/login.aspx?cmdName=1692",
      bypass: "N",
      parametros: [
        { nome: "CodFrota", valor: "codigoFrota" }   
      ]
    },
    {
      erro: 9,
      tipoEntidade: 6,
      dscerro: "Horário",
      url: environment.sistemas.online_url + "/login.aspx?cmdName=1692",
      bypass: "N",
      parametros: [
        { nome: "CodFrota", valor: "codigoFrota" },
        { nome: "CodSubFrota", valor: "codigoSubfrota" }     
      ]
    },
    {
      erro: 9,
      tipoEntidade: 7,
      dscerro: "Horário",
      url: environment.sistemas.online_url + "/login.aspx?cmdName=1692",
      bypass: "N",
      parametros: [
        { nome: "CodFrota", valor: "codigoFrota" },
        { nome: "CodSubFrota", valor: "codigoSubfrota" },        
        { nome: "CodVeiculo", valor: "codigoVeiculo" }        
      ]
    },
    {
      erro: 10,
      dscerro: "Posto Combustível",
      tipoEntidade: 2,
      url: environment.sistemas.veiculobloqueio_url + "/login/Index?cmdName=2330",
      bypass: "N",
      parametros: []
    }
  ];

  constructor(
    private authenticationService: AuthenticationService,
    private registroTransacoesService: RegistroTransacoesService,
    private snackBar: SnackBarService,
    private renderer: Renderer2,
    private router: Router,
    public dialog: MatDialog,
    private dialogRef: MatDialogRef<DetalheRegistroTransacaoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IDadosListaBloqueio,
    private sanitizer: DomSanitizer,
    private http: HttpClient) {
    this.dadosLista = data;
  }


  ngOnInit(): void {

    this.loading++;

    this.usuario = this.registroTransacoesService?.usuario;

    // Verifica se o guid do usuário é ou continua válido.
    this.authenticationService.validate(this.registroTransacoesService?.usuario?.retorno?.guid ?? '')
      .then((dados => {

        if (!dados.sucesso) {
          this.snackBar.flashMessage(this.authenticationService.msgSessaoExpirada, ['snackbar-error'], 'Fechar', 0);
          this.usuario = undefined;
        } else {
        }
      }))
      .catch(() => {
        this.snackBar.flashMessage(this.authenticationService.msgSessaoExpirada, ['snackbar-error'], 'Fechar', 0);
      })
      .finally(() => {
        this.loading--;
      });

    this.dataSource = this.dadosLista.listaBloqueios;
    this.columns = this.configurarDadosTela();

  }
  ngAfterViewInit() {
    if (this.usuario) {
      if (this.dadosLista) {
        this.filtraListaApresentacao();
      }
    }
  }



  public configurarDadosTela(): any[] {
    var retornoId = this.data.codTipoEntidadeBloqueio;
    //console.log(retornoId);
    var result = this.templateColunas.find(template => template.cmdName === retornoId);

    this.tituloFuncionalidade = result?.tituloRelatorio;
    if (result?.columnDefinitions) {
      this.columnRowData = result?.columnDefinitions;
    }

    return result ? result.colunas : [];
  }

  filtraListaApresentacao() {
    this.filteredList = this.dataSource.filter(item => item.codTipoEntidadeBloqueio === this.data.codTipoEntidadeBloqueio);

    console.log('Filtered List:', this.filteredList);

    // Atualiza a fonte de dados e a tabela
    this.extendedTable.dataSource = this.filteredList;
    this.extendedTable.atualizaDados();
  }

  applyFilter(filterValue: string) {
    let filteredListFinder: any[];
    if (filterValue) {
      filterValue = filterValue.trim().toLowerCase();

      let keys = ['placa', 'modeloVeiculo', 'numeroDeFrota'];
      switch (this.data.codTipoEntidadeBloqueio) {
        case 7:
          keys = ['placa', 'modeloVeiculo', 'numeroDeFrota'];
          break;
        case 6:
          keys = ['codigoSubfrota', 'descricaoSubFrota'];
          break;
        case 2:
          keys = ['codigoFrota', 'fantasiaFrota'];
          break;

      }

      filteredListFinder = this.filteredList.filter(item => {
        return keys.some(key => {
          const itemValue = item[key];
          if (itemValue) {
            return itemValue.toString().toLowerCase().includes(filterValue);
          }

          return false;
        });
      });
    }
    else {
      filteredListFinder = this.filteredList;
    }

    this.extendedTable.dataSource = filteredListFinder;
    this.extendedTable.atualizaDados();

  }

  fechar() {
    this.dialogRef.close();
  }

  chamarTelaDestino(linhaSelecionada: any[]) {
    console.log(linhaSelecionada);
    var dadosRedirectErro = this.erroMapeamento.find(d => d.erro === this.data.codBloqueioId && d.tipoEntidade === this.data.codTipoEntidadeBloqueio)
    console.log(dadosRedirectErro);
    if (dadosRedirectErro != undefined && dadosRedirectErro.url != undefined && dadosRedirectErro.url != '') {
      if (dadosRedirectErro != undefined) {
        var url = this.buildUrlWithParams(dadosRedirectErro.url, dadosRedirectErro.parametros, linhaSelecionada);
        //this.url_redirect = this.sanitizer.bypassSecurityTrustResourceUrl(url);
        window.location.href = url;

        //this.ocultarDadosDetalhes = true;
      }
    } else {
      alert("Sem ação rápida para essa mensagem:\n" + dadosRedirectErro?.dscerro);
    }
  }

  loadContent(url: string): void {

    this.http.get(url, { responseType: 'text' }).subscribe({
      next: (data) => {
        this.content = this.sanitizer.bypassSecurityTrustHtml(data); // Sanitiza o conteúdo HTML
      },
      error: (err) => {
        console.error('Erro ao carregar a URL:', err);
      }
    });
  }

  private buildUrlWithParams(link: string, params: any[] | undefined, row: any): string {
    const url = new URL(link, window.location.origin);

    console.log(url);
    if (params != undefined) {
      console.log(params);
      params.forEach(param => {
        const value = row[param.valor]; // Obtém o valor do row baseado no campo 'valor'
        if (value !== undefined) {
          url.searchParams.append(param.nome, value);
        }
      });
      if (this.usuario != undefined)
        url.searchParams.append("userGuid", this.usuario?.retorno.guid);
    }
    console.log(url.toString());

    return url.toString();
  }

}
